/*
 * ******************************************************************
 * Copyright (c) 2023-2025 Broadcom. All Rights Reserved.
 * Broadcom Confidential. The term "Broadcom" refers to Broadcom Inc.
 * and/or its subsidiaries.
 * ******************************************************************
 */
import { Component, Input } from "@angular/core";

// @formatter:off
@Component({
    standalone: false,
    selector: "download-json",
    templateUrl: "./download-json.component.html",
    styleUrls: ["./download-json.component.scss"]
})
// @formatter:on
export class DownloadJsonComponent {
    @Input() json: any;
    @Input() fileName: string;

    public downloadObjectAsJson(): void {
        // JSON.stringify(this.json, null, 4) formats the json instead of a single line
        const data = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(this.json, null, 4));
        const downloadAnchorNode = document.createElement("a");
        downloadAnchorNode.setAttribute("href", data);
        downloadAnchorNode.setAttribute("download", this.fileName + ".json");
        document.body.appendChild(downloadAnchorNode); // required for firefox
        downloadAnchorNode.click();
        downloadAnchorNode.remove();
    }
}
